import { useRouteError, isRouteErrorResponse, Link } from "react-router-dom";
import { reportApplicationError } from "@/lib/error-reporting";
import { useEffect } from "react";

export function RootErrorBoundary() {
  const error = useRouteError();
  useEffect(() => {
    reportApplicationError(error, { boundary: "root_error_boundary" });
  }, [error]);

  const heading = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : "Something went wrong";
  const message = isRouteErrorResponse(error)
    ? ((error.data as string) ?? "This page could not be loaded.")
    : ((error as Error)?.message ?? "This page could not be loaded.");

  return (
    <main className="flex min-h-dvh items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="font-display text-4xl">{heading}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{message}</p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
          >
            Return home
          </Link>
        </div>
      </div>
    </main>
  );
}
